// 公司荣誉墙相关页面路由配置

// 懒加载组件
const enterpriseAward = (resolve) => require(["@/views/companyHonorWall/enterpriseAward/index.vue"], resolve); //企业奖项
const enterpriseAwardDetail = (resolve) => require(["@/views/companyHonorWall/enterpriseAward/detail.vue"], resolve); //企业奖项详情
const municipalEngineeringAwardDetail = (resolve) => require(["@/views/companyHonorWall/municipalEngineeringAward/detail.vue"], resolve); //市政工程获奖项目详情
const housingConstructionProject = (resolve) => require(["@/views/companyHonorWall/housingConstructionProject/index.vue"], resolve); //房建工程获奖项目
const municipalEngineeringAward = (resolve) => require(["@/views/companyHonorWall/municipalEngineeringAward/index.vue"], resolve); //市政工程获奖项目
const housingAwardsDetail = (resolve) => require(["@/views/companyHonorWall/housingConstructionProject/detail.vue"], resolve); //房建工程获奖项目详情
const staffAwardWinners = (resolve) => require(["@/views/companyHonorWall/staffAwardWinners/index.vue"], resolve); //员工获奖名单
const subwayProjectAwards = (resolve) => require(["@/views/companyHonorWall/subwayProjectAwards/index.vue"], resolve); //地铁工程获奖项目
const subwayProjectAwardsDetail = (resolve) => require(["@/views/companyHonorWall/subwayProjectAwards/detail.vue"], resolve); //地铁工程获奖项目详情
const personnelCertification = (resolve) => require(["@/views/companyHonorWall/personnelCertification/index.vue"], resolve); //人员执证
const personnelCertificationDetail = (resolve) => require(["@/views/companyHonorWall/personnelCertification/persAwardsDetail.vue"], resolve); //人员执证详情
const branchPerformance = (resolve) => require(["@/views/companyHonorWall/branchPerformance/index.vue"], resolve); //分支机构业绩
const branchPerFormanceDetail = (resolve) => require(["@/views/companyHonorWall/branchPerformance/branchPerFormanceDetail.vue"], resolve); //分支机构业绩详情
const housingConstruction = (resolve) => require(["@/views/companyHonorWall/summaryOfPerformance/housingConstruction/index.vue"], resolve); //添加房建业绩
const housingConstruction_Detail = (resolve) => require(["@/views/companyHonorWall/summaryOfPerformance/housingConstruction/housingConstruction_Detail.vue"], resolve); //房建业绩详情
const MunicipalPerformance = (resolve) => require(["@/views/companyHonorWall/summaryOfPerformance/MunicipalPerformance/index.vue"], resolve); //市政业绩
const subwayPerformance = (resolve) => require(["@/views/companyHonorWall/summaryOfPerformance/subwayPerformance/index.vue"], resolve); //地铁业绩
// 公司荣誉墙路由配置
const companyHonorWallRoutes = [{
        path: "/companyHonorWall/enterpriseAward",
        name: "enterpriseAward",
        component: enterpriseAward,
        meta: {
            title: "企业奖项",
            keepAlive: false,
            needLogin: true
        }
    },

    {
        path: "/companyHonorWall/enterpriseAward/detail/:contractNo",
        name: "enterpriseAwardDetail",
        component: enterpriseAwardDetail,
        meta: {
            title: "企业奖项详情",
            keepAlive: false,
            needLogin: true
        }
    },
    {
        path: "/companyHonorWall/housingConstructionProject",
        name: "housingConstructionProject",
        component: housingConstructionProject,
        meta: {
            title: "房建工程奖项",
            keepAlive: false,
            needLogin: true
        }
    },

    {
        path: "/companyHonorWall/housingConstructionProject/detail/:contractNo",
        name: "housingAwardsDetail",
        component: housingAwardsDetail,
        meta: {
            title: "房建工程奖项详情",
            keepAlive: false,
            needLogin: true
        }
    },


    {
        path: "/companyHonorWall/municipalEngineeringAward",
        name: "municipalEngineeringAward",
        component: municipalEngineeringAward,
        meta: {
            title: "市政工程奖项",
            keepAlive: false,
            needLogin: true

        }
    },
    {
        path: "/companyHonorWall/municipalEngineeringAward/detail",
        name: "municipalEngineeringAwardDetail",
        component: municipalEngineeringAwardDetail,
        meta: {
            title: "奖项详情", // 默认标题，会被动态更新
            keepAlive: false,
            needLogin: true,
            // 添加动态标题函数
            getTitle: (route) => {
                try {
                    const projectData = JSON.parse(route.query.projectData || '{}');
                    const { type, projectType } = projectData;

                    if (type === 1) {
                        return '人员获奖详情';
                    } else if (type === 2) {
                        return '企业奖项详情';
                    } else {
                        const titleMap = {
                            0: '市政工程奖项详情',
                            1: '房建工程奖项详情',
                            2: '地铁工程奖项详情'
                        };
                        return titleMap[projectType] || '工程奖项详情';
                    }
                } catch (error) {
                    return '奖项详情';
                }
            }
        }
    },
    {
        path: "/companyHonorWall/staffAwardWinners",
        name: "staffAwardWinners",
        component: staffAwardWinners,
        meta: {
            title: "员工获奖者",
            keepAlive: false,
            needLogin: true
        }
    },
    {
        path: "/companyHonorWall/subwayProjectAwards",
        name: "subwayProjectAwards",
        component: subwayProjectAwards,
        meta: {
            title: "地铁项目奖项",
            keepAlive: false,
            needLogin: true
        },

    },
    {
        path: "/companyHonorWall/subwayProjectAwards/detail/:contractNo",
        name: "subwayProjectAwardsDetail",
        component: subwayProjectAwardsDetail,
        meta: {
            title: "地铁项目奖项详情",
            keepAlive: false,
            needLogin: true
        }
    },

    {
        path: "/companyHonorWall/personnelCertification",
        name: "personnelCertification",
        component: personnelCertification,
        meta: {
            title: "人员执证",
            keepAlive: false,
            needLogin: true
        },

    },
    {
        path: "/companyHonorWall/personnelCertification/persAwardsDetail",
        name: "personnelCertificationDetail",
        component: personnelCertificationDetail,
        meta: {
            title: "人员执证详情",
            keepAlive: false,
            needLogin: true
        }
    },




    {
        path: "/companyHonorWall/branchPerformance",
        name: "branchPerformance",
        component: branchPerformance,
        meta: {
            title: "分支机构业绩",
            keepAlive: false,
            needLogin: true
        },

    },

    {
        path: "/companyHonorWall/branchPerformance/branchPerFormanceDetail",
        name: "branchPerFormanceDetail",
        component: branchPerFormanceDetail,
        meta: {
            title: "分支机构详情",
            keepAlive: false,
            needLogin: true
        },

    },

    {
        path: "/companyHonorWall/summaryOfPerformance/housingConstruction",
        name: "housingConstruction",
        component: housingConstruction,
        meta: {
            title: "房建业绩",
            keepAlive: false,
            needLogin: true
        },

    },

    {
        path: "/companyHonorWall/summaryOfPerformance/housingConstruction/housingConstruction_Detail",
        name: "housingConstruction_Detail",
        component: housingConstruction_Detail,
        meta: {
            // title: "房建业绩详情",
            title: "业绩详情",
            keepAlive: false,
            needLogin: true
        },

    },

    {
        path: "/companyHonorWall/summaryOfPerformance/MunicipalPerformance",
        name: "MunicipalPerformance",
        component: MunicipalPerformance,
        meta: {
            title: "市政业绩",
            keepAlive: false,
            needLogin: true
        },

    },

    {
        path: "/companyHonorWall/summaryOfPerformance/subwayPerformance",
        name: "subwayPerformance",
        component: subwayPerformance,
        meta: {
            title: "地铁业绩",
            keepAlive: false,
            needLogin: true
        },

    },
];

export default companyHonorWallRoutes;